/**
 * 对外报价模版配置相关路由
 * QuotationTemplateRulesList 规则列表页
 */
import Layout from '@/layout'


const pricingRouter = {
  QuotationTemplateRulesList: () => // 对外报价模版配置-规则列表页
    import('@/views/pricing-system/quotation-template/rules/list'),
	SUBSIDY_RULE_SETTING_MENU: () => import('@/views/pricing-system/subsidy-rule-setting/index'), // 补贴规则配置

}

const pricingRouters = [
	{
		path: '/quotation-template',
		component: Layout,
		name: 'QuotationTemplateRulesList',
		children: [
			{
				path: '/quotation-template/template/list',
				component: () => import('@/views/pricing-system/quotation-template/template/list'),
				name: 'QuotationTemplateList',
				hidden: true,
				meta: { title: '模版列表' }
			},
			{
				path: '/quotation-template/template/detail',
        component: () => import('@/views/pricing-system/quotation-template/template/template-detail'),
				name: 'QuotationTemplateDetail',
				hidden: true,
				meta: { title: '模版详情' }
			},
		]
	},
  {
    path: '/subsidy-rule-setting',
    component: Layout,
    name: 'SUBSIDY_RULE_SETTING_MENU',
    children: [
      {
        path: '/subsidy-rule-setting/add/:id?',
        component: () => import('@/views/pricing-system/subsidy-rule-setting/add'),
        name: 'SubsidyRuleSettingEdit',
        meta: { title: '补贴规则配置' }
      }
    ]
  }
]
export {
  pricingRouter,
  pricingRouters
}
